
import React, { useState, useEffect } from "react";
import redirectURL from "../redirectURL"; // your API instance
import { emitDataReceived } from '../socketManager';


const NegotiationCutoffTimer = ({
  biddingWindow,
  negotiationWindow,
  createDate,
  indent_id,
  vendorquotes = [],
  negotiation_timer_ends = 0
}) => {
  const [biddingLeft, setBiddingLeft] = useState("--:--");
  const [negotiationLeft, setNegotiationLeft] = useState("--:--");
  const [apiCalled, setApiCalled] = useState(false); // prevent multiple calls

  useEffect(() => {
    if (!createDate || !biddingWindow) {
      setBiddingLeft("--:--");
      setNegotiationLeft("--:--");
      return;
    }

    const parseWindow = (win) => {
      if (!win || typeof win !== "string" || !win.includes(":")) return [0, 0];
      const [h, m] = win.split(":").map(Number);
      return [h || 0, m || 0];
    };

    const [bH, bM] = parseWindow(biddingWindow);
    const [nH, nM] = parseWindow(negotiationWindow);

    // base create date (UTC → IST adjustment)
    const localCreateDate = new Date(createDate.replace("Z", "") + "+05:30");

    // bidding end time
    const biddingEndTime = new Date(localCreateDate);
    biddingEndTime.setHours(biddingEndTime.getHours() + bH);
    biddingEndTime.setMinutes(biddingEndTime.getMinutes() + bM);

    // negotiation end time (starts AFTER bidding ends)
    const negotiationEndTime = new Date(biddingEndTime);
    negotiationEndTime.setHours(negotiationEndTime.getHours() + nH);
    negotiationEndTime.setMinutes(negotiationEndTime.getMinutes() + nM);

    let timer;

    const startBiddingTimer = () => {
      timer = setInterval(() => {
        const now = new Date();
        if (now < biddingEndTime) {
          const diff = biddingEndTime - now;
          const h = String(Math.floor(diff / (1000 * 60 * 60))).padStart(2, "0");
          const m = String(Math.floor((diff / (1000 * 60)) % 60)).padStart(2, "0");
          const s = String(Math.floor((diff / 1000) % 60)).padStart(2, "0");
          setBiddingLeft(`${h}:${m}:${s}`);
        } else {
          setBiddingLeft("00:00:00");
          clearInterval(timer);
          // ✅ If no vendor quotes, negotiation should instantly expire
          if (!vendorquotes || vendorquotes.length === 0) {
            setNegotiationLeft("00:00:00");

            if (!apiCalled && negotiation_timer_ends != 1) {
              redirectURL
                .post("/consignments/updateNegotiationEnd", {
                  indent_id: indent_id,
                  negotiation_timer_ends: 1,
                })
                .then((resp) => {
                  emitDataReceived({})
                  console.log("Negotiation auto-ended (no quotes):", resp.data);
                })
                .catch((err) => {
                  console.error("API Error:", err);
                });

              setApiCalled(true);
            }
            return;
          }

          // ✅ If vendor quotes exist
          if (nH > 0 || nM > 0) {
            startNegotiationTimer();
          } else {
            // negotiation window = "00:00" → expire immediately
            setNegotiationLeft("00:00:00");

            if (!apiCalled && negotiation_timer_ends != 1) {
              redirectURL
                .post("/consignments/updateNegotiationEnd", {
                  indent_id: indent_id,
                  negotiation_timer_ends: 1,
                })
                .then((resp) => {
                  emitDataReceived({})
                  console.log("Negotiation ended instantly (0 window):", resp.data);
                })
                .catch((err) => {
                  console.error("API Error:", err);
                });

              setApiCalled(true);
            }
          }
        }
      }, 1000);
    };

    const startNegotiationTimer = () => {
      timer = setInterval(() => {
        const now = new Date();
        if (now < negotiationEndTime) {
          const diff = negotiationEndTime - now;
          const h = String(Math.floor(diff / (1000 * 60 * 60))).padStart(2, "0");
          const m = String(Math.floor((diff / (1000 * 60)) % 60)).padStart(2, "0");
          const s = String(Math.floor((diff / 1000) % 60)).padStart(2, "0");
          setNegotiationLeft(`${h}:${m}:${s}`);
        } else {
          setNegotiationLeft("00:00:00");
          clearInterval(timer);

          // ✅ Call Node API only once
          if (!apiCalled && negotiation_timer_ends != 1) {
            redirectURL
              .post("/consignments/updateNegotiationEnd", {
                indent_id: indent_id,
                negotiation_timer_ends: 1,
              })
              .then((resp) => {
                emitDataReceived({})
                console.log("Negotiation ended & updated:", resp.data);
              })
              .catch((err) => {
                console.error("API Error:", err);
              });

            setApiCalled(true);
          }
        }
      }, 1000);
    };

    startBiddingTimer();

    return () => clearInterval(timer);
  }, [biddingWindow, negotiationWindow, createDate, apiCalled, indent_id, vendorquotes]);

  return (
    <div className="d-flex gap-4">
      <span style={{ color: negotiationLeft === "00:00:00" ? "red" : "blue" }}>
        {negotiationLeft}
      </span>
    </div>
  );
};

export default NegotiationCutoffTimer;

